import React from 'react';
import { PageLayout } from '@/shared/layout';
import { InventoryKpiDashboard } from './components/InventoryKpiDashboard';
import { InventoryModulesGrid } from './components/InventoryModulesGrid';
import { RecentTransactions } from './components/RecentTransactions';
import { InventoryAIAssistant } from './components/InventoryAIAssistant';

export function InventoryPage() {
  return (
    <PageLayout
      title="Inventory Core Engine"
      description="Lõi thực thi Logistics. Quản lý luân chuyển vật lý, theo dõi số dư và sổ cái mọi điểm kho."
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <InventoryKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Vận hành Kho (Logistics)
              </h3>
            </div>
            <div className="flex-1">
              <InventoryModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-slate-500 rounded-full" />
                Giao dịch gần đây
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem sổ cái &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentTransactions />
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default InventoryPage;
